<template>
    <div class="content-wrapper" style="position: relative;">
        <div class="row text-center">
            <div class="col-md-12">
                <h3>&copy; BRAS SECURITY & SERVICES SARL</h3>
                <h2>POINTAGE BIOMETRIQUE</h2>
                <div id="result">{{ resultMessage }}</div>
                
                <div>
                    <div v-if="latitude && longitude" class="coordinates">
                        <p>Latitude: {{ latitude }} - Longitude: {{ longitude }}</p>
                    </div>
                <video
                ref="video"
                autoplay
                :class="videoBorderClass"
                id="video"
                ></video>
                <canvas ref="canvas" id="canvas" style="display: none;"></canvas>
                </div>
                <br>
                <p>Cliquez sur le bouton ci-dessous pour lancer la reconnaissance</p>
                <button @click="recognizeFace" :disabled="isLoading" id="recognize">
                    {{ isLoading ? "En cours de traitement..." : "Lancer le pointage" }}
                </button>
                <div v-if="isLoading" class="loader" id="loader"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            resultMessage: "",
            videoBorderClass: "",
            latitude: "",
            longitude: "",
        };
    },
    methods: {
        async startWebcam() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                this.$refs.video.srcObject = stream;
            } catch (error) {
                alert("Error accessing webcam: " + error.message);
            }
        },
        async getGeolocation() {
            if (!navigator.geolocation) {
                alert("Geolocation is not supported by your browser.");
                return;
            }
            navigator.geolocation.getCurrentPosition(
                (position) => {
                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;
                },
                (error) => {
                alert("Error getting location: " + error.message);
                }
            );
        },
        async recognizeFace() {
            this.resultMessage = "";
            this.isLoading = true;
            this.videoBorderClass = ""; // Reset border class

            const video = this.$refs.video;
            const canvas = this.$refs.canvas;
            const context = canvas.getContext("2d");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            // Capture image
            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            // Convert canvas to Blob
            canvas.toBlob(async (blob) => {
                const formData = new FormData();
                formData.append("photo", blob, "photo.jpg");

                // Add geolocation data
                if (this.latitude !== null && this.longitude !== null) {
                    formData.append("latitude", this.latitude);
                    formData.append("longitude", this.longitude);
                }

                try {
                    const response = await fetch("recognize", {
                        method: "POST",
                        body: formData,
                    });

                    const result = await response.json();

                    if (response.ok && result.name) {
                        this.resultMessage = `Visage reconnu: ${result.name}`;
                        this.videoBorderClass = "border-success"; // Green border
                    } else {
                        this.resultMessage = "Face not recognized. Please try again.";
                        this.videoBorderClass = "border-error"; // Red border
                    }
                } catch (error) {
                    this.resultMessage = `Error contacting the server: ${error.message}`;
                    this.videoBorderClass = "border-error"; // Red border
                } finally {
                    this.isLoading = false;
                }
            }, "image/jpeg");
        },
    },
    mounted() {
        this.startWebcam();
        this.getGeolocation();
    },
};
</script>

<style scoped>
body {
    font-family: Arial, sans-serif;
    background-color: #f5f5f5;
    color: #333;
    text-align: center;
    padding: 20px;
}
h2 {
    color: #d66515;
}
#video {
    width: 100%;
    max-width: 400px;
    border: 4px solid #d66515;
    border-radius: 10px;
    margin-top: 20px;
    transition: border-color 0.3s ease;
}
.border-success {
    border-color: #28a745; /* Green */
}
.border-error {
    border-color: #dc3545; /* Red */
}
button {
    background-color: #d66515;
    color: #fff;
    padding: 15px 30px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    margin: 20px;
}
button:hover {
    background-color: #94450d;
}
button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}
.loader {
    display: block;
    margin: 20px auto;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #d66515;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
#result {
    margin-top: 20px;
    color: green;
    font-size: 24px;
    font-weight: bold;
}
</style>
